import React from 'react';
import 'twin.macro';
import _orderBy from 'lodash-es/orderBy';
import { Eleve } from 'types/eleves';
import { IPlannerEvent } from 'containers/Dashboard/PlannerEvents/types';
import { getElevesBirthdaysBetweenDates } from '@teetsh/app/src/utils/time/getElevesBirthdaysBetweenDates';
import setYear from 'utils/time/setYear';
import getYear from 'utils/time/getYear';
import { useCJConfigurationDisplay } from 'containers/CahierJournal/useCJConfigurationDisplay';

interface Props {
  day: Date;
  eleves: Eleve[];
  className?: string;
}

export function BirthDays(props: Props) {
  const { hideBirthdays } = useCJConfigurationDisplay();

  const birthdayEvents: IPlannerEvent[] = getElevesBirthdaysBetweenDates(
    props.eleves || [],
    props.day,
    props.day,
  ).map(ev => ({
    id: ev.id,
    title: `Anniversaire ${ev.givenName} ${ev.familyName}`,
    date: setYear(ev.birthday as Date, getYear(new Date())),
    type: 'birthday',
  }));
  if (hideBirthdays || birthdayEvents.length === 0) {
    return null;
  }
  return (
    <div tw="space-y-2 mb-2" className={props.className}>
      {_orderBy(birthdayEvents, ['date'], ['asc']).map(ev => (
        <div
          key={ev.id}
          tw="p-2 bg-neutral-supershy rounded-lg text-neutral-intense text-sm font-bold"
        >
          🎂 {ev.title}
        </div>
      ))}
    </div>
  );
}
